<template>
  <v-carousel class="section wow pulse" hide-delimiters style="margin-top: -70px">
    <v-carousel-item :src="require('../../public/images/home/1_01.jpg')">
      <v-container fill-height fluid>
        <v-layout fill-height align-center>
          <v-flex xs12 md12 lg12 text-xs-center white--text>
            <div class="display-1 mx-3" v-if="device === 'desktop'">资产大航海时代的领航者</div>
            <div class="title mx-3" v-if="device === 'mobile'">资产大航海时代的领航者</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-carousel-item>
    <v-carousel-item :src="require('../../public/images/home/1_02.jpg')">
      <v-container fill-height fluid>
        <v-layout fill-height align-center>
          <v-flex xs12 md12 lg12 text-xs-center white--text>
            <template v-if="device === 'desktop'">
              <div class="headline my-3 mx-3">迦南资本致力于提供</div>
              <div class="headline my-3 mx-3">专业的全球化资产配置与物业运营服务</div>
              <div class="headline my-3 mx-3">深度的原汁原味的海外生活体验</div>
            </template>
            <template v-if="device === 'mobile'">
              <div class="title my-3 mx-3">迦南资本致力于提供</div>
              <div class="title my-3 mx-3">专业的全球化资产配置与物业运营服务</div>
              <div class="title my-3 mx-3">深度的原汁原味的海外生活体验</div>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </v-carousel-item>
    <v-carousel-item :src="require('../../public/images/home/1_03.jpg')">
      <v-container fill-height fluid>
        <v-layout fill-height align-center>
          <v-flex xs12 md12 lg12 text-xs-center white--text>
            <div class="display-1 mx-3" v-if="device === 'desktop'">挖掘洼地资产，专注财富增值</div>
            <div class="title mx-3" v-if="device === 'mobile'">挖掘洼地资产，专注财富增值</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-carousel-item>
    <v-carousel-item :src="require('../../public/images/home/1_04.jpg')">
      <v-container fill-height fluid>
        <v-layout fill-height align-center>
          <v-flex xs12 md12 lg12 text-xs-center white--text>
            <div class="display-1 mx-3" v-if="device === 'desktop'">体验海外慢节奏，品味当地原生活</div>
            <div class="title mx-3" v-if="device === 'mobile'">体验海外慢节奏，品味当地原生活</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { WOW } from 'wowjs'

export default {
  data() {
    return {}
  },
  created() {
    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>
